module.exports = __webpack_public_path__ + "img/loudspeaker.cf354d79.png";